import React, { useEffect, useState } from 'react';
import {  Link, Button } from 'carbon-components-react';
import { ComboBox, Loading} from 'carbon-components-react';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { setAdminSelection } from '../../redux/actions/admin-actions';
import { AdminSelection } from '../../components/enums/admin-selection';
import useMsalApi from '../../components/use-msal-api';
import { updateEnrollments } from '../../redux/actions/enrollments-actions';
import { EnrollmentType } from '../../components/enums/enrollment-type';
import { setAdminSessions } from '../../redux/actions/admin-actions';
import EmployeeLookup from './employee-lookup';
import ClaycoForm from '../../components/form_elements/clayco-form';
import { RequiredNumber } from '../../components/form_elements/form-validators';
import * as Yup from 'yup';

const Admin = () => {
    const [employees, setEmployees] = useState([]);
    const [processing, setProcesing] = useState(false);
    const navigate = useNavigate();
    const {accounts, instance} = useMsal();
    const dispatch = useDispatch();
    const [callApi] = useMsalApi();
    const [selectedEmployeeGuid, setSelectedEmployeeGuid] = useState();
    const admin = useSelector(s => s.admin);
    const [sessions, setSessions] = useState([]);

    useEffect(() => {
        if(!admin?.isAdmin === true)
            navigate("/");
        const getEmp = async (session) => {
            const id = session.createdOnBehalfOf;
            console.log("ID:", id);
            const results = await getDisplayName(id)
            const item = {
                id: session.id,
                employeeGuid: id,
                displayName: results.displayName,
                email: results.mail
            }
            
            return item;
        };

        const getEmployees = async (sessions) => {
            var results = await Promise.all(sessions.map(getEmp));
            setSessions(results);
        }

    
        if(admin?.sessions?.length > 0){
            getEmployees(admin?.sessions);
        }
    }, [admin])

    
    const validationSchema = Yup.object().shape({
        employeeNumber: RequiredNumber("Required")
    });

    const onSubmit = async(formData) => {
        setProcesing(false);

        const frm = validationSchema.cast(formData);

        const results = await callApi(`Enrollments/enroll/${frm.employeeNumber}`, "GET");
        if(!results.error){
            dispatch(updateEnrollments(results));
            navigate("/");

          }
          setProcesing(false);
      }



    const getBenefits = async (employeeGuid) => {
        setProcesing(true);
        var path = !employeeGuid ? "Enrollments" : `Enrollments/${employeeGuid}`;
        const results = await callApi(path, "GET");
        if(!results.error){
          dispatch(updateEnrollments(results));
          return results;
        }
        setProcesing(false);

      }
  

    const selectEmployee = (e) => {
        if(!e)
            return
            
        console.log(e.selectedItem);
        setSelectedEmployeeGuid(e.selectedItem.id);
    }
    const enrollEmployee = async (e) => {
        dispatch(setAdminSelection(AdminSelection.OnBehalfOfEmployee));
        await getBenefits(selectedEmployeeGuid);
        getAdminActivity();
        navigate("/");
    }

    const enrollSelf = (e) => {
        dispatch(setAdminSelection(AdminSelection.OnBehalfOfEmployee));
        dispatch(updateEnrollments([]));
        getBenefits();
        navigate("/");
    }

    const continueEnrollment = async (employeeGuid) => {
        var results = await getBenefits(employeeGuid);
        if(results.enrollmentTypeId === EnrollmentType.BenficiaryChange){
            navigate("/Beneficiaries");
        } else {
            const steps = [
                {index: 0, url: "/", label: "Start", description: "Start"},
                {index: 1, url: "/Employee", label: "Emp. Data", description: "Enter Employee Data"},
                {index: 2, url: "/Dependents", label: "Dependents", description: "Enter Dependent Data"},
                {index: 3, url: "/Medical", label: "Medical", description: "Select Medical Plan"},
                {index: 4, url: "/Dental", label: "Dental", description: "Select Dental Plan"},
                {index: 5, url: "/Vision", label: "Vision", description: "Select Vision Plan"},
                {index: 6, url: "/Disability", label: "Disability", description: "Review Disability"},
                {index: 7, url: "/LifeInsurance", label: "Life Ins.", description: "Select Life Insurance"},
                {index: 8, url: "/FSA", label: "FSA", description: "Select FSA Plans"},
                {index: 9, url: "/Review", label: "Review", description: "Review"}
            ]

            const page = steps.find(s => s.index === results.currentStep)?.url;
            if(page)
                navigate(page);
            else
                navigate("/");
        }
    }

    const getAdminActivity = async () => {
        const results = await callApi("Enrollments/ActiveCreatedByMe", "GET");
        if(!results.error)
          dispatch(setAdminSessions(results));
      }


    const searchEmployees = async (query) => {
        const headers = new Headers();
        const bearer = `Bearer ${ await getAccessToken()}`;
    
        headers.append("Authorization", bearer);
    
        const options = {
            method: "GET",
            headers: headers
        };

        const url = `https://graph.microsoft.com/beta/users?$select=id,mail,displayName
            &$filter=(((startswith(surname,'${query}')) OR (startswith(givenName,'${query}'))  OR (startswith(displayName,'${query}'))) 
                AND accountEnabled eq true 
                AND onPremisesSyncEnabled eq true 
                AND mail ge '!')`;
    
        return fetch(url, options)
            .then(response => response.json())
            .catch(error => console.log(error));
    };

    const getDisplayName = async (query) => {
        const headers = new Headers();
        const bearer = `Bearer ${ await getAccessToken()}`;
    
        headers.append("Authorization", bearer);
    
        const options = {
            method: "GET",
            headers: headers
        };

        const url = `https://graph.microsoft.com/beta/users/${query}?$select=mail,displayName`;
    
        return fetch(url, options)
            .then(response => {
                console.log("REPOSN", response);
                if(response.status === 200){
                    console.log("success");

                    return response.json()
                }
                else {
                    console.log("fao;ed");
                    return {
                        displayName: "NEW HIRE",
                        mail: "Don't know"
                    }
        
                }
            })
            .catch(error => console.log("JKLD"));
    };


    async function getAccessToken(){
        const request = {
          scopes: ["User.Read", "profile", "User.Read.All", "Group.Read.All"],
          account: accounts[0]
        }
        try {
          return  (await instance.acquireTokenSilent(request)).accessToken;
        } catch {
          return (await instance.acquireTokenPopup(request)).accessToken;
        }
      } 


    const search = async (e) => {
        console.log("searching for...", e);
        if(!e || e.length < 3){
            setEmployees([{id: 1, name: "Start Typing an employee's name to see results"}]);
            return;
        }


        var results = await searchEmployees(e);
        const options = results.value.map((i) => ({
            email: i.mail,
            id: i.id,
            displayName: i.displayName,
            name: `${i.displayName} (${i.mail})`
        }));

        setEmployees(options);
    }


    return (    
        <>
            <div className="font-bold text-3xl">Employee Benefits Admin</div>
            <div className="text-lg mt-2">Please select what you want to do...</div>

            <div className='grid md:grid-cols-2 grid-cols-1 gap-8 mt-8'>
                <div className="pr-4 pb-8 relative border-r border-black md:border-solid">
                    <div className="text-xl mb-4">Actions</div>
                    <div>
                        <p className="text-sm">Select one of the following actions:</p>
                    </div>
                    <div className="py-4 pl-2 ml-4 mr-8 border-b border-slate-300 border-solid">
                        <Link role="button" size="lg" onClick={() => navigate('/Admin/PendingSubmissions')}>View Pending Submissions</Link>
                    </div>
                    <div className="py-4 pl-2 ml-4 mr-8 border-b border-slate-300 border-solid">
                        <Link role="button" size="lg" onClick={() => navigate('/Admin/ApprovedSubmissions')}>View Approved, In Progress Submissions</Link>
                    </div>
                    <div className="py-4 pl-2 ml-4 mr-8 border-b border-slate-300 border-solid">
                        <Link role="button" size="lg" onClick={() => navigate('/Admin/OpenEnrollmentReport')}>View Open Enrollment Report</Link>
                    </div>

                </div>  
                <div className="pr-4 pb-8 relative">
                    <div className="text-xl mb-4">Enroll On-Behalf Of</div>
                    {processing ? <>
                        <div className='my-4 text-lg font-bold'>Loading Data...</div>
                        <Loading withOverlay={false} />
                    </> :<>
                    {sessions?.length > 0 ?
                        <div className='mb-4'>
                            <div>Continue session for</div>
                            {sessions.map((s) => 
                                <div key={s.id} className="py-4 pl-2 ml-4 mr-8 border-b border-slate-300 border-solid">
                                    <Link role="button" onClick={() => continueEnrollment(s.employeeGuid)} > {s.displayName}</Link>
                                </div>
                            )}
                            <div className="text-lg mt-4">Or</div>
                        </div>
                    : <></>
                    }
                    <div className="pb-8">
                        <p className="text-sm">Select an employee</p>
                        <ComboBox id="employeeSelect" items={employees} onChange={selectEmployee} onInputChange={search}
                                        itemToString={ (item) => item ? item["name"] : ''}
                                        />
                    </div>
                    <div className="pb-4">
                        <Button onClick={enrollEmployee}>Enroll Employee</Button>
                    </div>
                    <div className="text-lg mt-4">Or</div>
                    <EmployeeLookup />
                    </>
                    }
                </div>                     
            </div>                   
               

        </>
     );
}
 
export default Admin;